import { supabase } from '@/lib/supabase'

export type RoleRewardsPolicyRow = { role: string; rewards_enabled: boolean }
export type PlanRewardsPolicyRow = { plan_id: string; rewards_enabled: boolean }

export async function fetchRoleRewardsPolicies(): Promise<RoleRewardsPolicyRow[]> {
  const { data, error } = await supabase
    .from('role_rewards_policies')
    .select('role,rewards_enabled')
    .order('role', { ascending: true })
  if (error) throw error
  return ((data || []) as any[]).map((r) => ({ role: r.role, rewards_enabled: !!r.rewards_enabled }))
}

export async function fetchPlanRewardsPolicies(): Promise<PlanRewardsPolicyRow[]> {
  const { data, error } = await supabase
    .from('plan_rewards_policies')
    .select('plan_id,rewards_enabled')
    .order('plan_id', { ascending: true })
  if (error) throw error
  return ((data || []) as any[]).map((r) => ({ plan_id: r.plan_id, rewards_enabled: !!r.rewards_enabled }))
}

export async function upsertRoleRewardsPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_rewards_policies')
    .upsert({ role, rewards_enabled: enabled }, { onConflict: 'role' })
  if (error) throw error
}

export async function upsertPlanRewardsPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_rewards_policies')
    .upsert({ plan_id: planId, rewards_enabled: enabled }, { onConflict: 'plan_id' })
  if (error) throw error
}

